module.exports = __webpack_public_path__ + "img/boqinspect8_7-8-2021.3dd44301.jpg";